export default __webpack_public_path__ + "static/media/minutehand.771ed6fb.png";